<template>
  <div>
    <p>
      A dependent variable, also known as an outcome variable, is affected by
      one or more independent variables. Independent variables can include
      exposures or etiologic factors. For example, health is an outcome that may
      be affected by one or more independent variables, such as age, or
      diabetes.
    </p>

    <p>
      When setting up cross tabulations, analysts usually place the dependent
      variable (e.g., "General health") in rows. Independent variables (e.g.,
      "Reported Age 18-64, 65+") are placed in columns. This generally makes
      interpretation of results easier. You may want to refine your analysis
      further by adding one or two control variables. Doing so is optional, but
      it produces additional tables with a single analysis. Control variables
      may be extraneous factors or confounds. They can help refine conclusions
      that you would otherwise draw from a given analysis.
    </p>

    <p>
      For example, you may be interested in learning how human health is
      affected by age, and whether the effect of aging is reduced by exercise.
      To answer this in the WEAT, you would select "General health" as the
      dependent variable, " Reported Age 18-64, 65+" as the independent
      variable, and "Exercised in past 30 days" as a control variable. You could
      even add a second control such as "Ever told have diabetes" to determine
      whether diabetes changes the effect of exercise on health among the
      elderly.
    </p>

    <p>
      When using the WEAT to perform logistic regression analyses, the dependent
      variables available to you all have dichotomous outcomes (e.g., at-risk or
      not at-risk). You can predict a given outcome by adding one or more
      dependent variables or predictors to the logistic model. The WEAT output
      will display an odds ratio for each predictor in the model. An odds ratio
      describes the relative risk associated with a particular level (e.g., male
      or female) for the given predictor.
    </p>
  </div>
</template>

<script>
import current from "@/scripts/current";

export default {
  data: function () {
    current.initializeVariableHelper();
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>